/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClaimResponse } from '../../models/claim-response';

export interface CasesCaseIdStepsStepIdClaimPost$Params {
  caseId: string;
  stepId: string;
}

export function casesCaseIdStepsStepIdClaimPost(http: HttpClient, rootUrl: string, params: CasesCaseIdStepsStepIdClaimPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ClaimResponse>> {
  const rb = new RequestBuilder(rootUrl, casesCaseIdStepsStepIdClaimPost.PATH, 'post');
  if (params) {
    rb.path('caseId', params.caseId, {});
    rb.path('stepId', params.stepId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClaimResponse>;
    })
  );
}

casesCaseIdStepsStepIdClaimPost.PATH = '/cases/{caseId}/steps/{stepId}/claim';
